<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" max-width="400">
            <v-card>
                <v-card-title class="headline">{{ titleText }}</v-card-title>

                <v-card-text>
                    {{ content }}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="grey darken-1" text @click="decline">
                        {{ declineLabelText }}
                    </v-btn>

                    <v-btn
                        ref="ConfirmBtn"
                        color="primary"
                        depressed
                        @click="confirm"
                    >
                        {{ confirmLabelText }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    props: {
        content: {
            type: String,
            default: "Continue with this action?"
        },
        title: {
            type: String,
            default: null,
        },
        confirmLabel: {
            type: String,
            default: null,
        },
        declineLabel: {
            type: String,
            default: null,
        },
        value: {
            type: Boolean
        }
    },
    computed: {
        titleText() {
            return this.title || this.$t("GENERAL.LABELS.CONFIRM_TITLE");
        },
        confirmLabelText() {
            return this.confirmLabel || this.$t("GENERAL.LABELS.YES");
        },
        declineLabelText() {
            return this.declineLabel || this.$t("GENERAL.LABELS.NO");
        },
    },
    watch: {
        value() {
            this.dialog = this.value;
            if (this.dialog) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs.ConfirmBtn.$el.focus();
                    }, 10);
                });
            }
        },
        dialog() {
            this.$emit("input", this.dialog);
        }
    },
    data() {
        return {
            dialog: false
        };
    },
    methods: {
        confirm() {
            this.$emit("confirm");
            this.dialog = false;
        },
        decline() {
            this.$emit("decline");
            this.dialog = false;
        }
    }
};
</script>
